export default __webpack_public_path__ + "img/img_lachmi-103be0f75341fa14222e26a43f1b1c4e.jpg";